/**
 * Zustand store for managing optimizer modal UI state.
 */

import { create } from 'zustand';

interface OptimizerModalStore {
  isOptimizerModalOpen: boolean;
  optimizerModalTab: 'setup' | 'history';
  setOptimizerModalOpen: (open: boolean) => void;
  setOptimizerModalTab: (tab: 'setup' | 'history') => void;
  /**
   * Reset to the default (closed) state. Called on logout/login (SHA-71) so
   * a previous account's open modal/tab doesn't carry into the next
   * account's session.
   */
  reset: () => void;
}

export const useOptimizerModalStore = create<OptimizerModalStore>((set) => ({
  isOptimizerModalOpen: false,
  optimizerModalTab: 'setup',
  setOptimizerModalOpen: (open) => set({ isOptimizerModalOpen: open }),
  setOptimizerModalTab: (tab) => set({ optimizerModalTab: tab }),
  reset: () => set({ isOptimizerModalOpen: false, optimizerModalTab: 'setup' }),
}));
